import axios from 'axios';

const WordpressAPI = axios.create({
  baseURL: 'http://54.247.62.45/wp-json/wp/v2',
});

export default WordpressAPI;